import { render, staticRenderFns } from "./PostCommentEdit.vue?vue&type=template&id=32c05154&"
import script from "./PostCommentEdit.vue?vue&type=script&lang=js&"
export * from "./PostCommentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports